import { useState } from "react";
import type { Faq } from "@/types";

export default function FaqAccordion({ items }: { items: Faq[] }) {
  const [openId, setOpenId] = useState<string>(items[0]?.id ?? "");

  return (
    <div className="divide-y divide-foreground-950/10 border-y border-foreground-950/10">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenId(isOpen ? "" : item.id)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 py-5 text-left"
              >
                <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                  {item.q}
                </span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-foreground-950/15 text-foreground-700 transition-transform ${
                    isOpen ? "rotate-180 bg-primary-600 text-background-50" : ""
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-lg" aria-hidden="true"></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <p className="max-w-3xl pb-6 text-sm leading-relaxed text-foreground-600 md:text-base">
                {item.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}